import AppLayout from '@components/layouts/appLayout';

import { StoryFooter } from '../components/layout/StoryFooter';
import { StoryHeader } from '../components/layout/StoryHeader';
import { StoryWrapper } from '../components/layout/StoryWrapper';
import VideoPlayer from '../components/video/VideoPlayer';
import { VideoPlayerProvider } from '../contexts/VideoPlayerContext';
import { StoryPageDisplay, StoryPageType } from '../enums';
import { useStrapiVideo } from '../hooks/useStrapiVideo';
import { Renderer as RendererType, Tester } from '../types';

export const Renderer: RendererType = ({ story, storyPage }) => {
    const { poster, src } = useStrapiVideo(storyPage);
    return (
        <VideoPlayerProvider storyPage={storyPage}>
            <AppLayout
                hasFixedFooter
                footerHasPointerEvents={false}
                header={
                    <StoryHeader
                        withExit={false}
                        story={story}
                        storyPage={storyPage}
                    />
                }
                body={
                    <StoryWrapper>
                        <VideoPlayer src={src} poster={poster} />
                    </StoryWrapper>
                }
                footer={
                    <StoryFooter
                        withNavigationButtons
                        storyPage={storyPage}
                        withCtas={false}
                        withVideoPlayerButtons={true}
                    />
                }
            />
        </VideoPlayerProvider>
    );
};

export const tester: Tester = (display, storyPage) => {
    return {
        condition:
            display === StoryPageDisplay.Flow &&
            storyPage.type === StoryPageType.Video,
        priority: 6,
    };
};

const rendererWithTester = { renderer: Renderer, tester };

export default rendererWithTester;
